import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section } from "../components/LegalLayout";
import { useContent } from "../context/ContentContext";

export default function PrivacyPolicy() {
  const { content } = useContent();
  const COMPANY = content.company;
  return (
    <LegalLayout eyebrow="Informativa" title="Privacy Policy" updated="Agosto 2026">
      <p className="mb-8 text-[0.95rem]">
        La presente informativa è resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (“GDPR”)
        e del D.Lgs. 196/2003 (“Codice Privacy”) a coloro che interagiscono con questo sito e con i
        servizi di {COMPANY.name}.
      </p>

      <Section n="1" title="Titolare del trattamento">
        <p>
          Il Titolare del trattamento è <strong>{COMPANY.name}</strong>, con sede in {COMPANY.address}
          {" "}— P. IVA {COMPANY.piva}.
        </p>
        <p>
          Email: <a href={`mailto:${COMPANY.email}`} className="text-gold underline underline-offset-2">{COMPANY.email}</a>
          {" · "}Telefono: <a href={`tel:${COMPANY.phoneHref}`} className="text-gold underline underline-offset-2">{COMPANY.phone}</a>
        </p>
      </Section>

      <Section n="2" title="Dati personali trattati">
        <p>Trattiamo i dati che ci fornisci volontariamente, in particolare:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Dati di contatto</strong> inseriti nel modulo di richiesta preventivo: nome e cognome, numero di telefono, indirizzo email ed eventuale messaggio.</li>
          <li><strong>Dati di navigazione</strong> tecnici (necessari al funzionamento del sito) e archiviazione locale del consenso ai cookie.</li>
        </ul>
      </Section>

      <Section n="3" title="Finalità e base giuridica">
        <ul className="list-disc pl-5 space-y-1">
          <li>Rispondere alle richieste di preventivo e fornire informazioni sui nostri servizi — base giuridica: esecuzione di misure precontrattuali (art. 6.1.b GDPR) e consenso dell'interessato (art. 6.1.a).</li>
          <li>Adempiere a obblighi di legge (fiscali e amministrativi) — art. 6.1.c GDPR.</li>
          <li>Garantire il corretto funzionamento e la sicurezza del sito — legittimo interesse (art. 6.1.f).</li>
        </ul>
      </Section>

      <Section n="4" title="Modalità del trattamento">
        <p>
          I dati sono trattati con strumenti elettronici, adottando misure di sicurezza adeguate a
          prevenire la perdita, l'uso illecito o non corretto e l'accesso non autorizzato.
        </p>
      </Section>

      <Section n="5" title="Periodo di conservazione">
        <p>
          I dati raccolti tramite il modulo sono conservati per il tempo necessario a gestire la
          richiesta e l'eventuale rapporto commerciale, nonché per i termini previsti dalla legge.
          Decorso tale periodo i dati sono cancellati o resi anonimi.
        </p>
      </Section>

      <Section n="6" title="Destinatari e responsabili">
        <p>
          I dati non sono diffusi. Possono essere trattati, in qualità di Responsabili del trattamento,
          da fornitori di servizi strumentali al funzionamento del sito:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>Cloudflare, Inc.</strong> — infrastruttura di hosting, rete di distribuzione dei
            contenuti (CDN) e database in cui sono archiviate le richieste di preventivo. I dati del
            database sono ospitati su infrastruttura Cloudflare in territorio dell'Unione Europea.
          </li>
          <li>
            <strong>Resend</strong> — invio al Titolare delle email di notifica delle richieste di
            preventivo.
          </li>
        </ul>
        <p>
          Alcuni fornitori hanno sede negli Stati Uniti: eventuali trasferimenti di dati verso Paesi
          extra-UE avvengono nel rispetto di garanzie adeguate ai sensi del GDPR (clausole contrattuali
          standard e/o adesione al Data Privacy Framework).
        </p>
      </Section>

      <Section n="7" title="Diritti dell'interessato">
        <p>In qualità di interessato puoi esercitare in qualsiasi momento i diritti previsti dagli artt. 15-22 del GDPR:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>accesso, rettifica e cancellazione dei dati;</li>
          <li>limitazione e opposizione al trattamento;</li>
          <li>portabilità dei dati;</li>
          <li>revoca del consenso in qualsiasi momento.</li>
        </ul>
        <p>
          Per esercitare i tuoi diritti scrivi a{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-gold underline underline-offset-2">{COMPANY.email}</a>.
          Hai inoltre il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati
          personali (www.garanteprivacy.it).
        </p>
      </Section>

      <Section n="8" title="Cookie">
        <p>
          Per informazioni dettagliate sull'uso dei cookie consulta la{" "}
          <Link to="/cookie" className="text-gold underline underline-offset-2">Cookie Policy</Link>.
        </p>
      </Section>

      <Section n="9" title="Intelligenza artificiale e contenuti del sito">
        <p>Ai fini di trasparenza, anche in relazione al Regolamento (UE) 2024/1689 (“AI Act”):</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Il sito è stato progettato e realizzato con l'ausilio di strumenti di intelligenza artificiale.</li>
          <li>Le immagini a corredo hanno finalità puramente illustrativa e provengono da archivi fotografici (stock); non costituiscono deepfake né rappresentazioni artificiali di persone o fatti reali.</li>
          <li>Il sito <strong>non</strong> impiega sistemi di intelligenza artificiale che interagiscono con i visitatori (es. chatbot), né effettua profilazione o processi decisionali automatizzati sui dati degli utenti ai sensi dell'art. 22 del GDPR.</li>
        </ul>
      </Section>
    </LegalLayout>
  );
}
